import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Select from '@components/_Layout/Controls/Select';
import { SelectOptionType } from '../../../types';
import { useSession } from '@hooks';

type BillsAreaProps = {
  //
};

const rangeDateOptions: SelectOptionType[] = [
  {
    value: "01-02-2021_31-12-2021",
    label: "Du 01/01/2021 au 31/12/2021"
  },
  {
    value: "01-02-2022_31-12-2022",
    label: "Du 01/01/2022 au 31/12/2022"
  },
  {
    value: "01-02-2023_31-12-2023",
    label: "Du 01/01/2022 au 31/12/2022"
  }
]

const bills = [
  {
    range: "01-02-2021_31-12-2021",
    bills: [
      {
        label: "Diffus Argelès-Sur-Mer 01/01/2021",
        status: "Réception de la facture en cours",
        montantTTC: 96.26,
        restantduTTC: 96.26,
      },
      {
        label: "Diffus Argelès-Sur-Mer 01/04/2021",
        status: "Réception de la facture en cours	",
        montantTTC: 696.26,
        restantduTTC: 696.26,
      },
      {
        label: "Diffus Argelès-Sur-Mer 01/07/2021",
        status: "En attente de la réception de la quittance de loyer",
        montantTTC: 96.26,
        restantduTTC: 96.26,
      }
    ]
  },
  {
    range: "01-02-2022_31-12-2022",
    bills: [
      {
        label: "Diffus Argelès-Sur-Mer 01/01/2021",
        status: "Réception de la facture en cours",
        montantTTC: 16.26,
        restantduTTC: 86.26,
      }
    ]
  },
  {
    range: "Du 01/01/2023 au 31/12/2023",
    bills: null
  }
]

const languagesVarsCodes = [
  "LANG_neobooking_invoice", //Factures
  "LANG_neobooking_invoice_issued", //Mes factures émises
  "LANG_neobooking_invoice_label", //Libelle
  "LANG_neobooking_invoice_status", //Statut
  "LANG_neobooking_invoice_amount", //Montant TTC
  "LANG_neobooking_invoice_amount_rest_of", //Restant dû TTC
  "LANG_neobooking_invoice_no_invoice", //Aucune facture pour cette période
]

const BillsArea: React.FC<BillsAreaProps> = () => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  /* State */
  const [range, setRange] = useState<string>(rangeDateOptions[0].value)
  const [selectedBills, setSelectedBills] = useState(bills.find(x => x.range === range))

  useEffect(() => {
    setSelectedBills(bills.find(x => x.range === range))
  }, [range])

  return <div>
    <span className="tw-block tw-font-bold">{getLanguageVarValue("LANG_neobooking_invoice")} (données en dur)</span>
    <div className="tw-my-6">
      <Select options={rangeDateOptions} onChange={(e) => setRange(e.target.value)} />
      <span className="tw-block tw-my-4">{getLanguageVarValue("LANG_neobooking_invoice_issued")}</span>
      {
        (selectedBills && selectedBills.bills) ? <>
          <div className="tw-overflow-x-auto">
            <div className="tw-overflow-hidden"></div>
            <table className="tw-w-full tw-text-left tw-text-sm">
              <thead className="tw-bg-gray-50">
                <tr>
                  <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_invoice_label")}</th>
                  <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_invoice_status")}</th>
                  <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_invoice_amount")}</th>
                  <th className="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-500 tw-uppercase tw-tracking-wider">{getLanguageVarValue("LANG_neobooking_invoice_amount_rest_of")}</th>
                </tr>
              </thead>
              <tbody className="tw-bg-white">
                {
                  selectedBills.bills.map((item, index) => {
                    return <tr className="hover:tw-bg-gray-50" key={`tr_bill_${index}`}>
                      <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap">
                        {item.label}
                      </td>
                      <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap">
                        {item.status}
                      </td>
                      <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap">
                        {item.montantTTC}
                      </td>
                      <td className="tw-px-6 tw-py-4 tw-whitespace-nowrap">
                        {item.restantduTTC}
                      </td>
                    </tr>
                  })
                }
              </tbody>
            </table>
          </div>
        </>
          :
          <>
            <span className="tw-block">{getLanguageVarValue("LANG_neobooking_invoice_no_invoice")}</span>
          </>
      }
    </div>
  </div>;
};

BillsArea.propTypes = {
  //
};

export default BillsArea;
